import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'


const CurrentTab = styled.div`
  height:41px;
  cursor:pointer;
  text-decoration:none;
  font-family:Poppins;
  flex: 1;
  color:#166DD8;
  &{
    border-bottom:3px solid #166DD8;
  }
`
const OtherTab = styled(Link)`
  cursor:pointer;
  text-decoration:none;
  color:black;
  flex: 1;
  font-family:Poppins;
`
const InfoContainerBar = styled.div`
  display:flex;
  flex-direction:row;
  justify-content:space-around;
  text-align:center;
  font-size:1.1rem;
  font-weight:400;
  style:normal;
  width:100%;
  margin:auto;
  margin-top:5rem;
  border-bottom: 1px solid #979797;
`

const InfoContainer = (props) => {
  const [color, setColor] = useState([])
  const [borderBottom, setBorderBottom] = useState([])

    // switch color in the infoContainer to know where we are
    const onClickColor = (e) => {
        setColor([
        e === 0 ? '#166DD8' : 'black',
        e === 1 ? '#166DD8' : 'black',
        e === 2 ? '#166DD8' : 'black'
        ])
        setBorderBottom([
        e === 0 ? '3px solid #166DD8' : 'black',
        e === 1 ? '3px solid #166DD8' : 'black',
        e === 2 ? '3px solid #166DD8' : 'black'
        ])
    }

    const selectedTab = props.path.split('/')[2]

    const tabs = ['edit', 'trainings', 'statsb2vm']
    const tabsName = ['Informations', 'Formations', 'Statistiques']

    const displayTabs = tabs.map( (tab, index) => {
        if (tab === selectedTab)
        {
            return (
                <CurrentTab
                    style={{
                        color: color[index],
                        borderBottom: borderBottom[index]
                        }}  
                    onClick={(e) => onClickColor(index)}
                    key={index}
                >
                {tabsName[index]}
                </CurrentTab>
            );
        }
        else
        {
            return (
                <OtherTab
                    to={{ pathname: `/simuplayers/${tab}/${props.playerId}`, query: { id: props.playerId } }}
                    style={{
                        color: color[index],
                        borderBottom: borderBottom[index]
                        }}  
                    onClick={(e) => onClickColor(index)}
                    key={index}
                >
                    {tabsName[index]}
                </OtherTab>
            );
        }
    });

    return (
        <InfoContainerBar>
            {displayTabs}
        </InfoContainerBar>
    )
  }
  export default InfoContainer